import React from 'react';
import { Routes, Route } from 'react-router-dom';
import JuliaProfile from './JuliaProfile';
import { detectAIAgentRoute } from '../../utils/routingUtils';

const AIAgentApp = () => {
  const { isSubdomain } = detectAIAgentRoute();

  // For subdomain routing (ai-agent.innovaplus.be), show agent profile directly
  if (isSubdomain) {
    return (
      <Routes>
        <Route path="/" element={<JuliaProfile />} />
        <Route path="/profile" element={<JuliaProfile />} />
        <Route path="/contact" element={<JuliaProfile />} />
        {/* Add more routes as needed */}
      </Routes>
    );
  }

  // For path-based routing (/ai-agent/*), include agent names in paths
  return (
    <Routes>
      <Route path="" element={<JuliaProfile />} />
      <Route path="julia" element={<JuliaProfile />} />
      <Route path="julia/profile" element={<JuliaProfile />} />
      <Route path="julia/contact" element={<JuliaProfile />} />
      {/* Future agents can be added here */}
      {/* <Route path="alex" element={<AlexProfile />} /> */}
      {/* <Route path="sarah" element={<SarahProfile />} /> */}
    </Routes>
  );
};

export default AIAgentApp; 